import * as RadixPopover from '@radix-ui/react-popover'
import type React from 'react'
import { isNonNil } from 'utils'

import { SpriteMap } from '../global'
import { Icon } from './Icon'

interface Props {
  children: React.ReactNode
  iconClassName?: string
  icon?: keyof typeof icons
  side?: RadixPopover.PopoverContentProps['side']
  align?: RadixPopover.PopoverContentProps['align']
  trigger?: React.ReactElement
  showArrow?: boolean
  open?: boolean
  onOpenChange?: (open: boolean) => void
}

const icons = {
  info: SpriteMap.InfoIcon,
  warning: SpriteMap.AlertIcon
} as const satisfies Record<string, SpriteMap>

export const Popover: React.FC<Props> = ({
  children,
  icon = 'info',
  iconClassName = 'h-5',
  side = 'bottom',
  align,
  trigger,
  showArrow = true,
  open,
  onOpenChange
}) => {
  return (
    <RadixPopover.Root open={open} onOpenChange={onOpenChange}>
      <RadixPopover.Trigger asChild={isNonNil(trigger)}>
        {trigger ?? <Icon icon={icons[icon]} className={iconClassName} />}
      </RadixPopover.Trigger>
      <RadixPopover.Portal>
        <RadixPopover.Content side={side} align={align} sideOffset={5} className="z-50">
          {children}
          {showArrow && <RadixPopover.Arrow />}
        </RadixPopover.Content>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  )
}
